import React, { useRef } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Style } from './style';
import Widget from '../../widget';
import DDUptake from './components/DDUptake';
import InfoCompleteness from './components/InfoCompleteness';
import MineSiteValidation from './components/MineSiteValidation';
import CorrectiveActionPlan from './components/CorrectiveActionPlan';

export const TooltipStyle = styled.div`
  position: absolute;
  width: 268px;
  left: 0px;
  z-index: 2;
  padding: 12px var(--size);
  border: 1px solid #F2F4F7;
  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  border-radius: 4px;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;


const InformationCompleteness = ({ data, loading }) => {
  const ref = useRef();
  const { t } = useTranslation();

  return (
    <section className="flex-1" ref={ref}>
      <Widget title={t('Due Diligence Indicators')}>
        <Style>
          <InfoCompleteness loading={loading} data={data?.informationCompletion} />
          <DDUptake loading={loading} data={data?.dueDiligenceUptake} />
          <MineSiteValidation loading={loading} data={data?.mineSiteValidation} />
          <CorrectiveActionPlan loading={loading} data={data?.correctivePlan} />
        </Style>
      </Widget>
    </section>
  );
};

export default InformationCompleteness;
